// Brez uvozov, da ga test (tools/prijava.test.mjs) požene v Node.

export type AvailableLocales = 'sl' | 'en'

const JEZIKI: readonly AvailableLocales[] = ['sl', 'en']

/** Jezik ob zagonu: shranjen (`localStorage.locale`), če ga vmesnik pozna, sicer sl. */
export const zacetniJezik = (shranjen: string | null): AvailableLocales =>
    JEZIKI.find((jezik) => jezik === shranjen) ?? 'sl'
